interface SVGIconProps {
  color?: string;
}
export const TeamIcon = ({ color = "black" }: SVGIconProps) => (
  <svg
    viewBox="0 0 18 16"
    height="100%"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.8155 5.81818C12.54 5.81818 13.128 6.38836 13.128 7.09091V11.9993C13.128 13.0603 12.6933 14.0779 11.9196 14.8282C11.1459 15.5785 10.0965 16 9.00225 16C7.90803 16 6.85863 15.5785 6.0849 14.8282C5.31118 14.0779 4.8765 13.0603 4.8765 11.9993V7.09091C4.8765 6.38836 5.46375 5.81818 6.189 5.81818H11.8155ZM1.3125 5.81818L4.599 5.81673C4.32874 6.13252 4.16603 6.52177 4.13325 6.93091L4.12575 7.09091V11.9993C4.12575 12.8233 4.344 13.5985 4.72575 14.2735C4.21194 14.4908 3.65038 14.5807 3.09177 14.535C2.53317 14.4893 1.9951 14.3094 1.52614 14.0115C1.05718 13.7137 0.672101 13.3073 0.405659 12.829C0.139217 12.3507 -0.000197937 11.8156 2.10924e-07 11.272V7.09091C0.000199049 6.75329 0.138647 6.42957 0.384907 6.19091C0.631168 5.95225 0.964335 5.81818 1.3125 5.81818ZM13.4055 5.81673L16.6875 5.81818C17.412 5.81818 18 6.38836 18 7.09091V11.2727C18.0002 11.8161 17.8609 12.351 17.5946 12.8291C17.3284 13.3073 16.9435 13.7136 16.4748 14.0114C16.0061 14.3092 15.4683 14.4892 14.9099 14.5351C14.3516 14.581 13.7902 14.4913 13.2765 14.2742L13.3185 14.2C13.6402 13.6087 13.836 12.9425 13.872 12.2364L13.878 11.9993V7.09091C13.878 6.60655 13.7003 6.16291 13.4055 5.81673ZM9 0C9.34472 -7.04429e-09 9.68606 0.0658401 10.0045 0.193761C10.323 0.321682 10.6124 0.509179 10.8562 0.745547C11.0999 0.981914 11.2933 1.26252 11.4252 1.57135C11.5571 1.88018 11.625 2.21118 11.625 2.54545C11.625 2.87973 11.5571 3.21073 11.4252 3.51956C11.2933 3.82839 11.0999 4.109 10.8562 4.34536C10.6124 4.58173 10.323 4.76923 10.0045 4.89715C9.68606 5.02507 9.34472 5.09091 9 5.09091C8.30381 5.09091 7.63613 4.82273 7.14384 4.34536C6.65156 3.868 6.375 3.22055 6.375 2.54545C6.375 1.87036 6.65156 1.22291 7.14384 0.745547C7.63613 0.268181 8.30381 1.42266e-08 9 0ZM15.0023 0.727273C15.2977 0.727273 15.5903 0.783707 15.8633 0.893354C16.1363 1.003 16.3843 1.16371 16.5932 1.36631C16.8022 1.56891 16.9679 1.80943 17.081 2.07415C17.1941 2.33886 17.2523 2.62257 17.2523 2.90909C17.2523 3.19561 17.1941 3.47933 17.081 3.74404C16.9679 4.00875 16.8022 4.24927 16.5932 4.45187C16.3843 4.65447 16.1363 4.81518 15.8633 4.92483C15.5903 5.03447 15.2977 5.09091 15.0023 5.09091C14.4055 5.09091 13.8332 4.86104 13.4113 4.45187C12.9893 4.0427 12.7523 3.48775 12.7523 2.90909C12.7523 2.33044 12.9893 1.77548 13.4113 1.36631C13.8332 0.957142 14.4055 0.727273 15.0023 0.727273ZM2.99775 0.727273C3.29322 0.727273 3.58581 0.783707 3.85879 0.893354C4.13177 1.003 4.37981 1.16371 4.58874 1.36631C4.79767 1.56891 4.96341 1.80943 5.07648 2.07415C5.18955 2.33886 5.24775 2.62257 5.24775 2.90909C5.24775 3.19561 5.18955 3.47933 5.07648 3.74404C4.96341 4.00875 4.79767 4.24927 4.58874 4.45187C4.37981 4.65447 4.13177 4.81518 3.85879 4.92483C3.58581 5.03447 3.29322 5.09091 2.99775 5.09091C2.40101 5.09091 1.82872 4.86104 1.40676 4.45187C0.984803 4.0427 0.74775 3.48775 0.74775 2.90909C0.74775 2.33044 0.984803 1.77548 1.40676 1.36631C1.82872 0.957142 2.40101 0.727273 2.99775 0.727273Z"
      fill={
        color
          ? color === "bluegradient"
            ? "url(#paint0_linear_586_2224)"
            : color === "purplegradient"
            ? "url(#paint0_linear_586_2224)"
            : color
          : "black"
      }
    />
    <defs>
      {color === "purplegradient" && (
        <linearGradient
          id="paint0_linear_586_2224"
          x1="0.2"
          y1="-4"
          x2="26.6022"
          y2="2.83473"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C72A8E" />
          <stop offset="1" stopColor="#7815DA" />
        </linearGradient>
      )}
      {color === "bluegradient" && (
        <linearGradient
          id="paint0_linear_586_2224"
          x1="-7.89109"
          y1="-5"
          x2="26.1628"
          y2="0.975647"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8E8EF2" />
          <stop offset="1" stopColor="#6911E7" />
        </linearGradient>
      )}
    </defs>
  </svg>
);
